import DelaysManager from "../../pages/delays/manager";
import DelaysParetoReport from "../../pages/delays/pareto";
import DelaysReport from "../../pages/delays/report";
import DelaysSankeyReport from "../../pages/delays/sankey";

export const routeDelaysManager = "/delays/manager";
export const routeDelaysReport = "/delays/report";
export const routeDelaysPareto = "/delays/pareto";
export const routeDelaysSankey = "/delays/sankey";
export const delaysManagerPermission = "ui.navbar.delays.manager";
export const delaysParetoPermission = "ui.navbar.delays.pareto";
export const delaysReportPermission = "ui.navbar.delays.report";
export const delaysSankeyPermission = "ui.navbar.delays.sankey";

export const delayRoutes = [
	{
		path: `${routeDelaysManager}`,
		element: <DelaysManager />,
		permission: delaysManagerPermission,
	},
	{
		path: `${routeDelaysManager}/:shiftId`,
		element: <DelaysManager />,
		permission: delaysManagerPermission,
	},
	{
		path: `${routeDelaysReport}`,
		element: <DelaysReport />,
		permission: delaysReportPermission,
	},
	{
		path: `${routeDelaysPareto}`,
		element: <DelaysParetoReport />,
		permission: delaysParetoPermission,
	},
	{
		path: `${routeDelaysSankey}`,
		element: <DelaysSankeyReport />,
		permission: delaysSankeyPermission,
	},
];
